import React, {useMemo, useState} from "react";
import {Alert, Form, Modal, Select, message} from "antd";
import {ApiApartmentsService} from "../../../../../shared/api";
import {FieldControl, fromForm, toForm} from "./fieldControls";
import {OLD_FORM_FIELDS, OLD_LABELS} from "./oldFlatLayout";

// «Массовая правка» (the owner, 27.10: «массово менять срок сдачи по корпусу или секции»): the flats chosen in the list
// get one value of one field, checked by the server as in the card (backend apartmentEditor.service bulkUpdate).
// Photos, view arrows, features, selections and the schedule are each flat's own: only in the card.

export const EDIT_KINDS = ['text', 'long', 'int', 'number', 'bool', 'date', 'list', 'curator']
const CARD_ONLY = ['installmentSchedule', 'coordsArrows', 'address', 'latitude', 'longitude']
// the fields changed for many flats at once most often, on top
const OFTEN = ['deadline', 'statuses', 'ads', 'rewardTitle', 'decorName', 'gradeName', 'salesman', 'assistant', 'encumbranceBank', 'agreement',
  'typeName', 'actualPrice', 'priceInAgreement']

const plural = (n, [one, few, many]) => {
  const tens = n % 100
  const ones = n % 10
  if (tens >= 11 && tens <= 14) return many
  if (ones === 1) return one
  if (ones >= 2 && ones <= 4) return few
  return many
}
export const flatsText = (n) => `${n.toLocaleString('ru-RU')} ${plural(n, ['квартира', 'квартиры', 'квартир'])}`

// references: loadReferences() (meta: fields, editable, lists; curators); ids: the flats chosen
export const BulkEditModal = ({open, ids, references, onClose, onDone}) => {
  const [fieldKey, setFieldKey] = useState('deadline')
  const [value, setValue] = useState()
  const [busy, setBusy] = useState(false)
  const {meta} = references
  const fields = useMemo(() => {
    const editable = new Set(meta.editable)
    return meta.groups.flatMap((g) => g.fields)
      .filter((f) => editable.has(f.key) && EDIT_KINDS.includes(f.kind) && !CARD_ONLY.includes(f.key))
      .map((f) => ({...f, label: OLD_LABELS[f.key] || f.title}))
  }, [meta])
  const field = fields.find((f) => f.key === fieldKey)
  const options = [
    {label: 'Часто', options: OFTEN.map((key) => fields.find((f) => f.key === key)).filter(Boolean).map((f) => ({value: f.key, label: f.label}))},
    {label: 'Все поля', options: [...fields].sort((a, b) => a.label.localeCompare(b.label, 'ru')).filter((f) => !OFTEN.includes(f.key))
      .map((f) => ({value: f.key, label: f.label}))},
  ]
  const choose = (key) => {
    const next = fields.find((f) => f.key === key)
    setFieldKey(key)
    setValue(next ? toForm(next.kind, null) : undefined)
  }
  const apply = async () => {
    if (!field) return
    setBusy(true)
    try {
      const {data} = await ApiApartmentsService.bulkUpdate(ids, {[field.key]: fromForm(field.kind, value)})
      message.success(`Изменено: ${flatsText(data.updated)}`)
      if (data.refused && data.refused.length) {
        Modal.warning({
          title: `Старый сайт не принял: ${flatsText(data.refused.length)}`,
          content: <ul className='old-errors'>{data.refused.slice(0, 20).map((r) => <li key={r.id}>№ {r.eciOldId}: {r.error}</li>)}</ul>,
        })
      }
      onDone()
    } catch (error) {
      message.error(error?.response?.data?.errors?.message || 'Не удалось изменить')
    }
    setBusy(false)
  }
  return (
    <Modal
      title={`Изменить поле у ${ids.length.toLocaleString('ru-RU')} ${plural(ids.length, ['квартиры', 'квартир', 'квартир'])}`}
      visible={open}
      onCancel={onClose}
      onOk={apply}
      okText='Изменить'
      cancelText='Отмена'
      confirmLoading={busy}
      okButtonProps={{disabled: !field}}
      destroyOnClose
    >
      <Form layout='vertical'>
        <Form.Item label='Поле'>
          <Select showSearch optionFilterProp='label' value={field ? fieldKey : undefined} placeholder='Выберите поле' options={options} onChange={choose}/>
        </Form.Item>
        {field && (
          <Form.Item label='Новое значение' extra='Пустое значение очистит поле у всех выбранных квартир'>
            {/* the same control as in the card: ECI old's list where it has one, the hints of «Прочие поля» (owner 03.11) */}
            <FieldControl key={field.key} field={field} list={meta.lists[field.key]} references={references} plain={OLD_FORM_FIELDS.has(field.key)} value={value}
              onChange={(v) => setValue(v && v.target ? v.target.value : v)}/>
          </Form.Item>
        )}
      </Form>
      <Alert type={meta.eciOldSave === 'live' ? 'info' : 'warning'} showIcon
        message={meta.eciOldSave === 'live'
          ? 'Квартиры со старого сайта сохраняются там по одной, как из его таблицы (не больше 30 за раз); те, что старый сайт не принял, не меняются и здесь.'
          : 'Квартиры со старого сайта: правка продержится до следующего изменения квартиры там или до ночной сверки.'}/>
    </Modal>
  )
}
